import React from "react";
import { Col, Row } from "react-bootstrap";
import BookingForm from "../components/BookUnit/BookingForm";

function BookUnit() {
  return (
    <>
      <Row>
        <Col xs={12} sm={12} md={12}>
          <BookingForm />
        </Col>
      </Row>
    </>
  );
}

export default BookUnit;
